
namespace RedBullMOBILE360.AutomaticReports {
    export class ReportLogColumns {
        static columnsKey = 'AutomaticReports.ReportLog';
    }
}